import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  OutlinedInput,
  Snackbar,
  Alert,
  Typography,
} from "@mui/material";
import {
  BUGS_OPT,
  CHATBOT_ICON_OPT,
  CHATBOT_SEND_ICON_OPT,
  FEATURE_OPT,
  FEEDBACK_OPT,
  IProductParams,
  MAIN_BUTTON,
} from "../../../model";
import { appLogger } from "../../../utils";
import DOMPurify from "dompurify";
import { withSnackbar } from "../../../utils/common/SnackbarHoc";

const IconUpload = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "handleChange",
      component: "add-product",
      fileName: "iconUpload.tsx",
      props: props,
    },
  });
  const {
    label,
    iconType,
    iconStr,
    productParams,
    setProductParams,
    snackbarShowMessage,
  } = props;
  const [icon, setIcon] = useState("");
  const [base64data, setBase64] = useState<string | undefined>();
  const [success, setSuccess] = useState(false);
  const [delIcon, setDelIcon] = useState(false);
  const [failiure, setFailure] = useState(false);

  useEffect(() => {
    if (iconStr) {
      // const returnedIcon = iconStr.replace(
      //   /\<\?xml.+\?\>|\<\!DOCTYPE.+]\>/g,
      //   ""
      // );
      // //   convertSVG(returnedIcon);
      setIcon(iconStr);
      setBase64(iconStr);
    } else {
      setIcon("");
      setBase64("");
    }
    // }
    // }, [product])
  }, [iconStr]);

  const handleIconChange = (event: any) => {
    const { type, dataInfo, iconStr } = event;
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (temp && temp.products && temp.products[0] && temp.products[0]) {
        switch (type) {
          case FEEDBACK_OPT: {
            if (
              temp.products[0].feedbackAgentSettings &&
              temp.products[0].feedbackAgentSettings.feedbackSettings
            ) {
              if (delIcon) {
                const filenames =
                  temp.products[0].feedbackAgentSettings.feedbackSettings?.icon?.split(
                    "/"
                  );
                const filename = filenames
                  ? filenames[filenames.length - 1]
                  : "";
                temp.products[0].feedbackAgentSettings.feedbackSettings.iconReq =
                  {
                    deleteFileName: filename,
                  };
              } else {
                temp.products[0].feedbackAgentSettings.feedbackSettings.iconReq =
                  dataInfo;
              }
              temp.products[0].feedbackAgentSettings.feedbackSettings.icon =
                iconStr;
            }
            break;
          }
          case BUGS_OPT: {
            if (
              temp.products[0].feedbackAgentSettings &&
              temp.products[0].feedbackAgentSettings.bugSettings
            ) {
              if (delIcon) {
                const filenames =
                  temp.products[0].feedbackAgentSettings.bugSettings?.icon?.split(
                    "/"
                  );
                const filename = filenames
                  ? filenames[filenames.length - 1]
                  : "";
                temp.products[0].feedbackAgentSettings.bugSettings.iconReq = {
                  deleteFileName: filename,
                };
              } else {
                temp.products[0].feedbackAgentSettings.bugSettings.iconReq =
                  dataInfo;
              }
              temp.products[0].feedbackAgentSettings.bugSettings.icon = iconStr;
            }
            break;
          }
          case FEATURE_OPT: {
            if (
              temp.products[0].feedbackAgentSettings &&
              temp.products[0].feedbackAgentSettings.featureReqSettings
            ) {
              if (delIcon) {
                const filenames =
                  temp.products[0].feedbackAgentSettings.featureReqSettings?.icon?.split(
                    "/"
                  );
                const filename = filenames
                  ? filenames[filenames.length - 1]
                  : "";
                temp.products[0].feedbackAgentSettings.featureReqSettings.iconReq =
                  {
                    deleteFileName: filename,
                  };
              } else {
                temp.products[0].feedbackAgentSettings.featureReqSettings.iconReq =
                  dataInfo;
              }
              temp.products[0].feedbackAgentSettings.featureReqSettings.icon =
                iconStr;
            }
            break;
          }
          case CHATBOT_ICON_OPT: {
            if (temp.products[0].chatAgentSettings) {
              temp.products[0].chatAgentSettings.chatbotIcon = iconStr;
            }
            break;
          }
          case CHATBOT_SEND_ICON_OPT: {
            if (temp.products[0].chatAgentSettings) {
              temp.products[0].chatAgentSettings.sendIcon = iconStr;
            }
            break;
          }
          case MAIN_BUTTON:
          default: {
            if (
              temp.products[0].feedbackAgentSettings &&
              temp.products[0].feedbackAgentSettings.widgetLookAndFeel
            ) {
              if (delIcon) {
                const filenames =
                  temp.products[0].feedbackAgentSettings.widgetLookAndFeel?.icon?.split(
                    "/"
                  );
                const filename = filenames
                  ? filenames[filenames.length - 1]
                  : "";
                temp.products[0].feedbackAgentSettings.widgetLookAndFeel.iconReq =
                  {
                    deleteFileName: filename,
                  };
              } else {
                temp.products[0].feedbackAgentSettings.widgetLookAndFeel.iconReq =
                  dataInfo;
              }
              temp.products[0].feedbackAgentSettings.widgetLookAndFeel.icon =
                iconStr;
            }
          }
        }
        setProductParams(temp);
      }
    }
  };

  const handleIconDelete = () => {
    const dataInfo = {
      deleteFileName: "",
    };
    setIcon("");
    setBase64("");
    setDelIcon(true);
    handleIconChange({ type: iconType, dataInfo, iconStr: "" });
  };
  const getFileExtension = (url: any) => {
    const parts = url.split(".");
    if (parts.length > 1) {
      return parts[parts.length - 1];
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else {
      return null;
    }
  };

  useEffect(() => {
    const fetchSvg = async () => {
      if (icon) {
        const fileExtension = getFileExtension(icon);
        if (fileExtension != "svg") {
          setIcon(icon);
          setBase64(icon);
        } else {
          try {
            const response = await fetch(icon);

            if (!response.ok) {
              throw new Error(
                `Failed to fetch SVG. Status: ${response.status}`
              );
            }
            const svgText = await response.text();
            setIcon(`data:image/svg+xml;base64,${btoa(svgText)}`);
            setBase64(`data:image/svg+xml;base64,${btoa(svgText)}`);
          } catch (error) {
            // console.error("Error fetching SVG:", error);
          }
        }
        setBase64("data:image/svg+xml;base64," + window.btoa(icon));
      }
    };
    fetchSvg();
  }, [icon]);

  const handleIconUpdate = (event: any) => {
    setIcon(event.target.value);
    handleIconChange({ type: iconType, iconStr: event.target.value });
  };

  const handleClose = () => {
    setFailure(false);
    setSuccess(false);
  };

  const handleClickEvent = (event: any) => {
    event.target.value = null;
  };

  function formatFileSize(bytes: number, decimalPoint: number) {
    if (bytes == 0) return "0 Bytes";
    const k = 1000,
      dm = decimalPoint || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    appLogger.info({
      infoObj: {
        method: "handleImageChange",
        component: "add-product",
        fileName: "iconUpload.tsx",
        file: file,
      },
    });
    const formUpload = new FormData();
    const size = file.size;
    const mb = 1000;
    const cur = formatFileSize(size, 2);
    if (!cur.includes("Bytes") && !cur.includes("KB")) {
      snackbarShowMessage(
        "Please upload an image with size less than 1 MB",
        "error",
        3000
      );
    } else {
      formUpload.append("file", file);
      formUpload.append("fileName", file.name);

      const reader = new FileReader();
      let dataInfo;
      reader.onload = function () {
        const [fileType, base64String] = String(reader.result).split("base64,");
        if (
          !(
            fileType.includes("png") ||
            fileType.includes("jpg") ||
            fileType.includes("jpeg")
          )
        ) {
          props.snackbarShowMessage("Unsupported image format!", "error", 3000);
          return;
        }
        let sanitizedBase64String;
        let sanitizedFile;
        if (fileType.includes("svg")) {
          const sanitizedString = DOMPurify.sanitize(atob(base64String));
          sanitizedBase64String = btoa(sanitizedString);
          sanitizedFile = new Blob([sanitizedString], {
            type: "image/svg+xml",
          });
        } else {
          sanitizedBase64String = base64String;
          sanitizedFile = file;
        }
        const extension = file.name.split(".")[1];
        dataInfo = {
          file: sanitizedBase64String,
          fileName: `${iconType}.${extension}`,
          deleteFileName: "",
        };
        const resultString = URL.createObjectURL(sanitizedFile);
        // handleImgChange(resultString, dataInfo, type);
        handleIconChange({
          type: iconType,
          dataInfo: dataInfo,
          iconStr: resultString,
        });
      };
      reader.onerror = function (event) {
        appLogger.error(
          {
            errObj: {
              method: "handleChange",
              component: "add-product",
              fileName: "iconUpload.tsx",
              err: new Error("Error uploading svg file"),
            },
          },
          "Error while uploading the svg file"
        );
        reader.abort();
      };
      reader.readAsDataURL(file);
    }
  };
  return (
    <Grid item xs={12}>
      <Box>
        <Typography className="title">
          Bot image :{" "}
          <span className="title-tooltip">
            (Image size must be less than 1 MB.) (Maximum image dimension should
            be 300 x 200 in png/jpg/jpeg format)
          </span>
          <div style={{ display: "inline-block", color: "red" }}>*</div>
        </Typography>
        <Box className="upload-wrap" sx={{ display: "flex" }}>
          {!base64data && (
            <Button
              variant="outlined"
              component="label"
              className="upload-btn"
              // onChange={(e: any) => setSelectedImage(e.target.files[0])}
            >
              <i className="icon-upload" />
              upload icon
              <input
                hidden
                accept=".png, .jpg, .jpeg"
                onClick={(event) => handleClickEvent(event)}
                onChange={(e) => handleImageChange(e)}
                type="file"
              />
            </Button>
          )}

          {base64data && (
            <Box className="img-preview">
              <img src={icon} />
            </Box>
          )}

          {base64data && (
            <i
              className="icon-delete cursor-pointer"
              onClick={handleIconDelete}
            />
          )}
          {success ? (
            <>
              {" "}
              <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={success}
                onClose={handleClose}
                autoHideDuration={2000}
              >
                <Alert> Svg file uploaded successfully</Alert>
              </Snackbar>
            </>
          ) : (
            <></>
          )}
          {failiure ? (
            <>
              {" "}
              <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={failiure}
                onClose={handleClose}
                autoHideDuration={2000}
              >
                <Alert severity={"error"}>
                  {" "}
                  File type error: Upload Svg Xml File
                </Alert>
              </Snackbar>
            </>
          ) : (
            <></>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default withSnackbar(IconUpload);
